// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1e0c1o8l{display:inline-block}
._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/calendar/dist/esm/calendar.compiled.css"],"names":[],"mappings":"AAAA,WAAW,oBAAoB;AAC/B,WAAW,wBAAwB,CAAC,oBAAoB,CAAC,gBAAgB","sourcesContent":["._1e0c1o8l{display:inline-block}\n._uiztglyw{-webkit-user-select:none;-ms-user-select:none;user-select:none}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
